import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PhoneWrapper from '../components/PhoneWrapper';
import Skeleton from '../components/Skeleton';
import { brandingForSeriesName } from '../data/meetings';
import { listPortalEvents, peekLive } from '../data/live';

function formatEventSub(ev) {
  if (!ev.start_date) return [ev.venue_city, ev.venue_state].filter(Boolean).join(', ');
  const d = new Date(ev.start_date + 'T12:00:00');
  const datePart = d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  const city = [ev.venue_city, ev.venue_state].filter(Boolean).join(', ');
  return [datePart, city].filter(Boolean).join(' · ');
}

export default function LandingPage() {
  // undefined = loading, null = couldn't load, [] / rows = loaded.
  // Starts from the saved list so a return visit renders instantly.
  const [events, setEvents] = useState(() => peekLive(listPortalEvents, []));
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let cancelled = false;
    if (attempt > 0) setEvents(undefined);
    listPortalEvents().then((rows) => {
      if (!cancelled) setEvents(rows);
    });
    return () => { cancelled = true; };
  }, [attempt]);

  // Live meetings only — a skeleton while loading, a retry message if the
  // list can't be loaded, never a hardcoded list that may be out of date.
  const cards = (events || []).map((ev) => {
    const branding = brandingForSeriesName(ev.meeting_series?.name || '');
    return {
      slug: ev.portal_slug || branding.slug,
      themeSlug: branding.slug,
      org: branding.org,
      logo: branding.logo,
      logoRatio: branding.logoRatio,
      // Full meeting name on the picker; the event-specific title appears on
      // the meeting's detail pages.
      primary: branding.fullName,
      sub: formatEventSub(ev),
    };
  });

  return (
    <PhoneWrapper>
      <div className="portal-statusbar" />
      <div className="portal-landing">
        <header>
          <div className="portal-landing-mono">GoIHES · 2026</div>
          <h1 className="portal-landing-title">Choose your meeting</h1>
        </header>
        {events === undefined && <Skeleton variant="card" count={4} />}
        {events !== undefined && !cards.length && (
          <div className="portal-empty">
            We couldn’t load the meetings. Check your connection and try again.
            <button type="button" className="portal-retry-btn" onClick={() => setAttempt((n) => n + 1)}>
              Try again
            </button>
          </div>
        )}
        <div className="portal-landing-list">
          {cards.map((c) => {
            return (
              <Link
                key={c.slug}
                to={`/${c.slug}`}
                className="portal-landing-card"
                data-meeting={c.themeSlug}
              >
                <div className="portal-landing-logo">
                  <img src={c.logo} alt={`${c.org} logo`} />
                </div>
                <div className="portal-landing-meta">
                  <div className="portal-landing-name">{c.primary}</div>
                  <div className="portal-landing-sub">{c.sub}</div>
                </div>
                <div className="portal-landing-chev" aria-hidden>›</div>
              </Link>
            );
          })}
        </div>
      </div>
    </PhoneWrapper>
  );
}
